<template>
  <div class="p-4">
    <offer-title-description
      class="mb-4"
      :title="currentGoodsOffer.title"
      :description="currentGoodsOffer.description"
      :central-cost-name="currentGoodsOffer.centralCost.name || ''"
    />
    <offer-goods-and-services
      :goods-offer-id="currentGoodsOffer.id"
      :goods-offer-status="currentGoodsOffer.status"
    />
    <goods-offer-accept
      v-if="currentGoodsOffer.isApprovalRequired"
      :goods-offer="currentGoodsOffer"
      @refresh="fetchGoodsOffer(currentGoodsOffer.id)"
    />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { useGoodsOffer } from './composables/use-goods-offer';
import VueStore from '@/store';
import OfferTitleDescription from '@/views/Brand/Applications/Components/Offers/OfferTitleDescription.vue';
import OfferGoodsAndServices from '@/views/Brand/Applications/Offer/_components/OfferGoodsAndServices/OfferGoodsAndServices.vue';
import GoodsOfferAccept from '@/views/Brand/Applications/Offer/_components/GoodsOfferAccept/GoodsOfferAccept.vue';

export default defineComponent({
  name: 'GoodsOfferDetails',
  components: {
    OfferTitleDescription,
    OfferGoodsAndServices,
    GoodsOfferAccept,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      await VueStore.dispatch(
        'goodsOffer/fetchGoodsOffer',
        to.params.goodsOfferId,
      );
    } catch (error) {
      console.error('Error loading goods offer:', error);
    }

    next();
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      await this.fetchGoodsOffer(to.params.goodsOfferId);
    } catch (error) {
      console.error('Error loading goods offer:', error);
    }

    next();
  },
  async beforeRouteLeave(to, from, next) {
    this.clearGoodsOffer();
    next();
  },

  setup() {
    const {
      currentGoodsOffer,
      isLoading,
      error,
      fetchGoodsOffer,
      clearGoodsOffer,
    } = useGoodsOffer();

    return {
      currentGoodsOffer,
      isLoading,
      error,
      fetchGoodsOffer,
      clearGoodsOffer,
    };
  },
});
</script>
